/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GuideVersionResource } from "./GuideVersionResource";
export const GuideVersionListResponse = core.serialization.object({
    data: core.serialization.list(GuideVersionResource),
});
